<template>
  <div ref="inputbox">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex position-relative align-items-center">
        <!-- 草稿或完成的履歷不會有未checked的review comment -->
        <div
          class="sr__badge sr__badge--sq sr__badge--fix mr-1"
          style="height: 24px;"
          v-if="!recordReviewed && existReviewComments"
        >需修正</div>

        <div
          v-if="item.validates?.presence || radioGroupRadioItem?.validates?.presence"
          class="sr__content-required"
        >*</div>

        <div
          class="sr__content"
          v-html="item?.content || radioGroupRadioItem?.content"
        ></div>
      </div>

      <div
        v-if="!isNormalGroupItem && isEditable && !recordReviewed && (canShowTag || existReviewComments)"
        @click="tag"
      >
        <b-icon icon="tags"></b-icon>
      </div>
    </div>

    <!-- normal group item -->
    <div
      v-for="(f, mixIdx) in flattenNormalInputMixItems"
      :key="`${f.input.iden}-${mixIdx}`"
      :style="{'padding-left': `${f.paddingLeft}px`}"
      class="pb-4"
    >
      <!-- normal input mix item-->
      <ServiceRecordItem
        v-if="f.input.mix_type !== 'normal'"
        :field="f.input"
        :disable="disable"
        :canShowTag="canShowTag"
      ></ServiceRecordItem>

      <!-- normal input mix validate message -->
      <div v-if="f.input.mix_type === 'normal' && validateLength">
        <b-form-invalid-feedback :state="valid">
          {{invalidMsg}}
        </b-form-invalid-feedback>
      </div>
    </div>

    <!-- radio group item -->
    <div v-if="radioGroupRadioItem">
      <b-form-radio-group
        v-model="radioGroupRadioItemValue"
        class="sr__radio-group"
        :disabled="disable"
      >
        <b-form-radio
          v-for="(option, oindex) in radioGroupRadioItem.value.value_options"
          :key="oindex"
          :value="option.value"
          class="sr__value"
        >
          {{option.title}}
        </b-form-radio>
      </b-form-radio-group>

      <div
        v-for="(option, oindex) in radioGroupRadioItem.value.value_options"
        :key="`item-${oindex}`"
      >
        <div v-if="radioGroupRadioItemValue === option.value">
          <ServiceRecordItem
            :field="radioGroupOptionsItem.value[oindex]"
            :disable="disable"
            :canShowTag="canShowTag"
          ></ServiceRecordItem>
        </div>
      </div>

    </div>

    <!-- date -->
    <DateItem
      v-if="item.type === 'input_date'"
      :field="item"
      :value.sync="item.value"
      :disable="disable"
      class="sr__value"
    ></DateItem>

    <!-- input -->
    <InputItem
      v-if="item.type === 'input'"
      :field="item"
      :value.sync="item.value"
      :disable="disable"
      class="sr__value"
    ></InputItem>

    <!-- raw -->
    <div v-if="item.type === 'raw'">
      <span class="sr__value">{{item.value}}</span>
    </div>

    <!-- raw array -->
    <div v-if="field.type === 'raw_array'">
      <span class="sr__value">{{item.value.join(",")}}</span>
    </div>

    <!-- input list -->
    <InputListItem
      v-if="item.type === 'input_list'"
      :field="item"
      class="sr__value"
      :disable="disable"
    >
    </InputListItem>

    <!-- input radio -->
    <InputRadioItem
      v-if="item.type === 'input_radio'"
      :field="item"
      :disable="disable"
    >
    </InputRadioItem>

    <!-- text area -->
    <TextAreaItem
      v-if="item.type === 'text_area'"
      :field="item"
      :value.sync="item.value"
      class="sr__value"
      :disable="disable"
    >
    </TextAreaItem>

    <!-- checkbox -->
    <CheckboxItem
      v-if="field.type === 'checkbox'"
      :field="item"
      :value.sync="item.value.value"
      :disable="disable"
    ></CheckboxItem>

    <!-- input option -->
    <InputOptionItem
      v-if="field.type === 'input_option'"
      :field="item"
      :disable="disable"
    ></InputOptionItem>

    <!-- diff value -->
    <DiffValueItem
      v-if="field.type === 'diff_value'"
      :field="item"
      :disable="disable"
    ></DiffValueItem>

    <!-- image group -->
    <ImageGroupItem
      v-if="field.type === 'image_group'"
      :field="item"
      :disable="disable"
    ></ImageGroupItem>
  </div>
</template>

<script>
import InputItem from './inputItem.vue'
import DateItem from './dateItem.vue'
import InputListItem from './inputListItem.vue'
import InputRadioItem from './inputRadioItem.vue'
import TextAreaItem from './textAreaItem.vue'
import CheckboxItem from './checkboxItem.vue'
import InputOptionItem from './inputOptionItem.vue'
import DiffValueItem from './diffValueItem.vue'
import ImageGroupItem from './imageGroupItem.vue'
import MicroModal from 'micromodal'

export default {
  name: 'ServiceRecordItem',
  props: {
    field: Object,
    disable: Boolean,
    canShowTag: Boolean,
    recordReviewed: Boolean
  },
  data () {
    return {
      item: {},
      // radio group item
      radioGroupRadioItem: null,
      radioGroupOptionsItem: null,
      radioGroupRadioItemValue: 0,

      // normal group item
      flattenNormalInputMixItems: [],
      validateLength: 0,
      validateLengthInputs: [],

      // validation
      valid: true,
      invalidMsg: ''
    }
  },
  watch: {
    radioGroupRadioItemValue: function () {
      this.radioGroupRadioItem.value.value[0] = this.radioGroupRadioItemValue
    }
  },
  computed: {
    isEditable () {
      return this.item.editable || this.radioGroupRadioItem?.editable
    },
    existReviewComments () {
      return this.item.review_comments?.some(e => !e.checked) || this.radioGroupRadioItem?.review_comments?.some(e => !e.checked)
    },
    isRadioGroupItem () {
      return this.field.mix_type === 'radio_group'
    },
    isNormalGroupItem () {
      return this.field.mix_type === 'normal'
    },
    isGroupItem () {
      return this.isNormalGroupItem || this.isRadioGroupItem
    }
  },
  created () {
    this.item = this.field

    if (this.isGroupItem) {
      this.setGroupItemData()
    }
  },
  mounted () {
    var top = this.$refs.inputbox.getBoundingClientRect().top

    if (this.validateLength) {
      this.$store.dispatch('pushValidateInfo', {
        id: this._uid,
        top: () => { return top },
        checkValueIsValid: this.checkValueIsValid
      })
    }
  },
  methods: {
    setGroupItemData () {
      if (this.isRadioGroupItem) {
        var mixOptions = this.field.mix_options

        this.radioGroupRadioItem = this.field.value.find(e => e.iden === mixOptions.radio_item)
        this.radioGroupOptionsItem = this.field.value.find(e => e.iden === mixOptions.options_item)
        this.radioGroupRadioItemValue = this.radioGroupRadioItem.value.value[0] || this.radioGroupRadioItemValue
      }

      if (this.isNormalGroupItem) {
        var validateLength = this.item.validates?.length
        if (validateLength) {
          this.validateLength = validateLength
        }

        this.flattenNormalInputMixItems = this.getFlattenNormalInputMix(this.item)
      }
    },
    tag () {
      this.$store.dispatch('setReviewItem', this.isRadioGroupItem ? this.radioGroupRadioItem : this.item)
      MicroModal.show('review-comment-modal')
    },
    getFlattenNormalInputMix (input, paddingLeft = 0, getInputToValidate = true) {
      var inputWrapper = { paddingLeft: paddingLeft, input: input }
      if (input.type !== 'input_mix' || input.mix_type !== 'normal') {
        return inputWrapper
      }

      var pl = paddingLeft + 14
      var flattenItems = [inputWrapper]

      input.value.forEach(e => {
        if (this.validateLength && getInputToValidate && e.type === 'text_area') {
          this.validateLengthInputs.push(e)
        }

        flattenItems = flattenItems.concat(this.getFlattenNormalInputMix(e, pl, false))
      })

      return flattenItems
    },
    checkValueIsValid (uiNotify = true) {
      if (!this.validateLength) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      if (this._isDestroyed) {
        this.valid = true
        this.invalidMsg = ''
        return true
      }

      var validLen = this.validateLengthInputs.filter(e => e.value).length

      if (validLen < this.validateLength) {
        if (!uiNotify) {
          return false
        }

        this.valid = false
        this.invalidMsg = `需填寫${this.validateLength}個`
      } else {
        this.valid = true
        this.invalidMsg = ''
      }

      return this.valid
    }
  },
  components: {
    InputItem,
    DateItem,
    InputListItem,
    InputRadioItem,
    TextAreaItem,
    CheckboxItem,
    InputOptionItem,
    DiffValueItem,
    ImageGroupItem
  }
}
</script>
